import { render, staticRenderFns } from "./FreeList.vue?vue&type=template&id=2b9dcf85&scoped=true"
import script from "./FreeList.vue?vue&type=script&lang=js"
export * from "./FreeList.vue?vue&type=script&lang=js"
import style0 from "./FreeList.vue?vue&type=style&index=0&id=2b9dcf85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9dcf85",
  null
  
)

export default component.exports